"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _context = require("../../context");

var _constants = require("../../form/input/constants");

var _utils = require("../../form/select/utils");

var _hooks = require("../../hooks");

var _useIsomorphicLayoutEffect = require("../../hooks/useIsomorphicLayoutEffect");

var _useStencilPopper2 = require("../../hooks/useStencilPopper");

var _constants2 = require("../../modal/constants");

var _utils2 = require("../../utils");

var _DropdownCustomLi = _interopRequireDefault(require("./DropdownCustomLi"));

var _DropdownLi = _interopRequireDefault(require("./DropdownLi"));

var _DropdownMetaItem = _interopRequireDefault(require("./DropdownMetaItem"));

var _DropdownUl = _interopRequireDefault(require("./DropdownUl"));

var _DropdownWrapper = _interopRequireDefault(require("./DropdownWrapper"));

var _VirtualizedList = require("./VirtualizedList");

var _constants3 = require("./constants");

var _helperComponents = require("./helperComponents");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

var _excluded = ["customSelectionOptions", "customSelectionOptionsLabel", "componentId", "defaultOptionsLabel", "hasOptionGroups", "footer", "getItemProps", "getListProps", "header", "highlightedIndex", "isAlwaysOpened", "isMulti", "isNavigation", "isOpen", "items", "itemToString", "labelId", "listMaxHeight", "listPositioningStrategy", "onPlacementChange", "renderItem", "selectedItem", "selectedItems", "target", "ulRef", "virtualizedListProps", "width", "borderRadius"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DropdownListBase = function DropdownListBase(_ref) {
  var _ref$customSelectionO = _ref.customSelectionOptions,
      customSelectionOptions = _ref$customSelectionO === void 0 ? [] : _ref$customSelectionO,
      customSelectionOptionsLabel = _ref.customSelectionOptionsLabel,
      _ref$componentId = _ref.componentId,
      componentId = _ref$componentId === void 0 ? 'StencilDropdown' : _ref$componentId,
      defaultOptionsLabel = _ref.defaultOptionsLabel,
      hasOptionGroups = _ref.hasOptionGroups,
      footer = _ref.footer,
      getItemProps = _ref.getItemProps,
      getListProps = _ref.getListProps,
      header = _ref.header,
      highlightedIndex = _ref.highlightedIndex,
      isAlwaysOpened = _ref.isAlwaysOpened,
      isMulti = _ref.isMulti,
      isNavigation = _ref.isNavigation,
      isOpen = _ref.isOpen,
      items = _ref.items,
      itemToString = _ref.itemToString,
      labelId = _ref.labelId,
      listMaxHeight = _ref.listMaxHeight,
      listPositioningStrategy = _ref.listPositioningStrategy,
      onPlacementChange = _ref.onPlacementChange,
      renderItem = _ref.renderItem,
      selectedItem = _ref.selectedItem,
      selectedItems = _ref.selectedItems,
      target = _ref.target,
      ulRef = _ref.ulRef,
      virtualizedListProps = _ref.virtualizedListProps,
      width = _ref.width,
      borderRadius = _ref.borderRadius,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var initialListMaxHeight = (0, _react.useRef)(_constants3.MINIMAL_HEIGHT);
  var virtualizedListRef = (0, _react.useRef)(null);
  var wrapperElementRef = (0, _react.useRef)(null);
  var dropdownWrapperRef = (0, _react.useRef)(null);
  var dropDownListRef = (0, _react.useRef)(null);
  var downshiftRef = ulRef || dropDownListRef;
  var gapHeight = selectors.space(_constants2.SCREEN_EDGE_GAP) || 0;
  var hasNoItems = items.length === 0;
  var itemsCount = hasOptionGroups ? items.reduce(function (prev, curr) {
    return [].concat((0, _toConsumableArray2.default)(prev), (0, _toConsumableArray2.default)(curr.values));
  }, []).length : items.length;
  var selectedItemsAsString = selectedItems && selectedItems.map(function (selectedItem) {
    return !!itemToString ? itemToString(selectedItem) : selectedItem;
  }); // Initial maxHeight to use in "trackScroll" modifier for popper

  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    if (target.current) {
      var maxHeightValue;

      if (typeof listMaxHeight === 'string') {
        var listMaxHeightDiv = document.createElement('div');
        listMaxHeightDiv.style.maxHeight = listMaxHeight;
        document.body.appendChild(listMaxHeightDiv);
        var maxHeightInPixels = window.getComputedStyle(listMaxHeightDiv, null).getPropertyValue('max-height');
        document.body.removeChild(listMaxHeightDiv);
        maxHeightValue = maxHeightInPixels ? parseInt(maxHeightInPixels, 10) : undefined;
      } else if (typeof listMaxHeight === 'number') {
        maxHeightValue = listMaxHeight;
      }

      if (!maxHeightValue) {
        var triggerHeight = target.current.offsetHeight;
        var calculatedHeight = (triggerHeight - _constants.BORDER_WIDTH) * _constants3.MAX_VISIBLE_ITEMS - _constants.BORDER_WIDTH * Math.floor(_constants3.MAX_VISIBLE_ITEMS / 2);
        maxHeightValue = calculatedHeight;
      }

      initialListMaxHeight.current = maxHeightValue + _constants.BORDER_WIDTH;
    }
  }, [listMaxHeight, target]);
  var modifiers = (0, _react.useMemo)(function () {
    return [{
      name: 'arrow',
      enabled: false
    }, {
      name: 'offset',
      options: {
        offset: [0, -_constants.BORDER_WIDTH]
      }
    }, {
      name: 'trackScroll',
      enabled: true,
      phase: 'main',
      fn: function fn(_ref2) {
        var _ref3;

        var state = _ref2.state;
        if (!target.current || !state.modifiersData.isOpen || !state || !state.rects || dropdownWrapperRef.current === null) return;
        var isFixed = listPositioningStrategy === 'fixed';
        var triggerTop = state.rects.reference.y;
        var absoluteHeight = triggerTop + state.rects.reference.height;
        var relativeHeight = triggerTop + state.rects.reference.height - (document.scrollingElement ? document.scrollingElement.scrollTop : 0);
        var triggerBottom = isFixed ? absoluteHeight : relativeHeight;
        var maxHeight = initialListMaxHeight.current;
        var isBottomStart = state.placement.includes('bottom');

        function setMaxHeightStyle(newMaxHeight) {
          // checking if isMounted and optimizing animation frames
          if (state.modifiersData.isMounted) {
            if (virtualizedListRef.current) {
              requestAnimationFrame(function () {
                if (!virtualizedListRef.current) return;

                if (virtualizedListProps) {
                  virtualizedListRef.current.style.maxHeight = newMaxHeight;
                }
              });
            } else {
              requestAnimationFrame(function () {
                if (virtualizedListProps || !dropdownWrapperRef.current) return;
                dropdownWrapperRef.current.style.maxHeight = newMaxHeight;
              });
            }
          } else {
            state.modifiersData.isMounted = true;

            if (virtualizedListProps && virtualizedListRef.current) {
              virtualizedListRef.current.style.maxHeight = newMaxHeight;
            } else if (dropdownWrapperRef.current && !virtualizedListProps) {
              dropdownWrapperRef.current.style.maxHeight = newMaxHeight;
            }
          }
        }

        var additionalGap = !!virtualizedListProps ? virtualizedListProps.itemHeight * 2 : 0;
        var scrollTop = isFixed ? 0 : (_ref3 = document.scrollingElement && document.scrollingElement.scrollTop) !== null && _ref3 !== void 0 ? _ref3 : 0;

        if (isBottomStart && maxHeight + triggerBottom > window.innerHeight) {
          setMaxHeightStyle("calc(100vh - ".concat(triggerBottom, "px - ").concat((0, _utils2.px)(gapHeight + additionalGap), ")"));
        } else if (!isBottomStart && triggerTop - scrollTop < maxHeight) {
          setMaxHeightStyle("calc(".concat(triggerTop - scrollTop, "px - ").concat((0, _utils2.px)(gapHeight + additionalGap), ")"));
        } else {
          setMaxHeightStyle(typeof listMaxHeight === 'string' ? listMaxHeight : (0, _utils2.px)(maxHeight));
        }
      }
    }, {
      name: 'flip',
      enabled: true,
      phase: 'main',
      fn: function fn(_ref4) {
        var state = _ref4.state;
        var oldPlacement = state.placement;
        var isInBottomPlacement = oldPlacement.includes('bottom');
        var absoluteHeight = window.innerHeight - state.rects.reference.y - state.rects.reference.height;
        var relativeHeight = (document.scrollingElement ? document.scrollingElement.scrollTop + document.scrollingElement.clientHeight : 0) - state.rects.reference.y;
        var spaceToBottom = listPositioningStrategy === 'fixed' ? absoluteHeight : relativeHeight;

        if (isInBottomPlacement && spaceToBottom < _constants3.MINIMAL_HEIGHT) {
          state.placement = oldPlacement.replace('bottom', 'top');
          state.reset = true;
        }
      }
    }];
  }, [target, virtualizedListProps, gapHeight, listMaxHeight, listPositioningStrategy]);

  var _useStencilPopper = (0, _useStencilPopper2.useStencilPopper)(target.current, wrapperElementRef.current, !!isOpen, {
    modifiers: modifiers,
    strategy: listPositioningStrategy
  }),
      styles = _useStencilPopper.styles,
      state = _useStencilPopper.state; //when moved to top from the bottom most item, the first group title should be visible


  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    if (downshiftRef && downshiftRef.current) {
      if (highlightedIndex === 0) {
        downshiftRef.current.scrollTop = 0;
      }
    }
  }, [downshiftRef, highlightedIndex]);
  var renderCustomListItem = (0, _react.useCallback)(function (item, index) {
    return (0, _core.jsx)(_DropdownCustomLi.default, {
      key: "h".concat(index),
      getItemProps: getItemProps,
      isHighlighted: index === highlightedIndex,
      item: item,
      index: index
    });
  }, [getItemProps, highlightedIndex]);
  var renderListItem = (0, _react.useCallback)(function (item, index, groupIndex) {
    var itemAsString = !!itemToString ? itemToString(item) : item;
    var itemIndex = index + customSelectionOptions.length; // Providing "aria-setsize" and "aria-posinset" props if virtualized list used
    // to announce invisible amount of items.
    // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-setsize

    var virtualizedListA11yProps = virtualizedListProps ? {
      'aria-posinset': index + 1,
      'aria-setsize': itemsCount
    } : {};
    var groupItemProps = groupIndex !== undefined && groupIndex >= 0 ? {
      'aria-describedby': "".concat(componentId, "-option-group-").concat(groupIndex),
      isGroupItem: true
    } : {};
    return (0, _core.jsx)(_DropdownLi.default, (0, _extends2.default)({
      key: itemAsString,
      getItemProps: getItemProps,
      renderItem: renderItem,
      isHighlighted: itemIndex === highlightedIndex,
      item: item,
      index: itemIndex,
      itemAsString: itemAsString,
      selectedItemsAsString: selectedItemsAsString,
      isSelected: (0, _utils.areValuesEqual)(selectedItem, item, itemToString),
      isNavigation: isNavigation
    }, groupItemProps, virtualizedListA11yProps));
  }, [componentId, customSelectionOptions, getItemProps, highlightedIndex, isNavigation, itemsCount, itemToString, renderItem, selectedItem, selectedItemsAsString, virtualizedListProps]);
  var wrapperProps = !isAlwaysOpened ? {
    ref: wrapperElementRef,
    style: styles.popper
  } : {
    isAlwaysOpened: isAlwaysOpened
  };

  var _useResizeObserver = (0, _hooks.useResizeObserver)({
    borderBoxSize: true,
    defaultElement: width === undefined && target.current ? target.current : undefined
  }),
      dropdownListWidth = _useResizeObserver.width;

  var renderGroupItems = function renderGroupItems(groupItems) {
    var itemIndex = -1;
    return groupItems.reduce(function (result, group, groupIndex) {
      return [].concat((0, _toConsumableArray2.default)(result), [(0, _core.jsx)(_helperComponents.OptionGroupName, {
        "aria-hidden": "true",
        "aria-label": _constants3.A11Y_GROUP_PREFIX + group.groupName,
        id: "".concat(componentId, "-option-group-").concat(groupIndex),
        key: groupIndex,
        role: "group"
      }, (0, _core.jsx)("span", {
        hidden: true
      }, _constants3.A11Y_GROUP_PREFIX), group.groupName)], (0, _toConsumableArray2.default)(group.values.map(function (item) {
        itemIndex++;
        return renderListItem(item, itemIndex, groupIndex);
      })));
    }, []);
  };

  var getFlattenGroups = function getFlattenGroups() {
    return Object.entries(items).map(function (a) {
      return [{
        name: a[1].groupName,
        type: _constants3.GROUP
      }].concat((0, _toConsumableArray2.default)(a[1].values));
    }).flat(Infinity);
  };

  var listItems;

  if (!!virtualizedListProps) {
    listItems = (0, _core.jsx)(_VirtualizedList.VirtualizedList, {
      hasHeader: !!header,
      hasFooter: !!footer,
      highlightedIndex: highlightedIndex,
      itemHeight: virtualizedListProps.itemHeight,
      items: hasOptionGroups ? getFlattenGroups() : items,
      ref: virtualizedListRef,
      renderListItem: renderListItem,
      selectedIndex: items && items.indexOf(selectedItem),
      visibleItems: virtualizedListProps.visibleItems,
      hasOptionGroups: hasOptionGroups,
      componentId: componentId
    });
  } else if (hasOptionGroups) {
    listItems = renderGroupItems(items);
  } else {
    listItems = items.map(function (item, index) {
      return renderListItem(item, index);
    });
  }

  (0, _react.useEffect)(function () {
    if (onPlacementChange && state && isOpen) onPlacementChange(state.placement);
  }, [isOpen, onPlacementChange, state, styles]);
  return (0, _core.jsx)(_helperComponents.ZIndexWrapper, (0, _extends2.default)({}, wrapperProps, {
    isOpen: !!isOpen
  }), (0, _core.jsx)(_DropdownWrapper.default, {
    borderRadius: borderRadius,
    height: "100%",
    isAlwaysOpened: isAlwaysOpened,
    isInTopPlacement: !state ? false : state.placement.includes('top'),
    isOpen: !!isOpen,
    maxHeight: isAlwaysOpened ? listMaxHeight : '100vh',
    ref: dropdownWrapperRef,
    style: hasNoItems && !header && !footer ? {
      display: 'none'
    } : undefined,
    width: width ? width : dropdownListWidth
  }, !!header && // dropdown is unreachable by keyboard events due to downshift
  // so handle down arrow key event manually to be able to focus on list
  (0, _core.jsx)(_DropdownMetaItem.default, {
    borderPosition: _interfaces.DropdownItemBorderPosition.Bottom,
    isOpen: !!isOpen,
    shouldHaveNoBorder: isAlwaysOpened || hasNoItems && !footer
  }, header), (0, _core.jsx)(_DropdownUl.default, (0, _extends2.default)({}, getListProps({
    ref: downshiftRef
  }, {
    suppressRefError: true
  }), labelId === undefined ? {
    'aria-labelledby': null
  } : {}, {
    "aria-multiselectable": isMulti ? 'true' : undefined,
    "aria-hidden": isOpen ? 'false' : 'true',
    hasPadding: isOpen && !hasNoItems
  }, (0, _utils2.pickDataProps)(forwardedProps)), isOpen && customSelectionOptions.length > 0 && (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_helperComponents.DropdownListLabel, {
    id: "custom-selection-label"
  }, customSelectionOptionsLabel), customSelectionOptions.map(renderCustomListItem), (0, _core.jsx)(_helperComponents.DropdownListLabel, null, defaultOptionsLabel)), isOpen && listItems), !!footer && // This has to appear inside the <ul> because downshift adds a focus trap to
  // the list, meaning that if the header and footer were outside the <ul>, a
  // screen reader would not be able to interact with them.
  (0, _core.jsx)(_DropdownMetaItem.default, {
    borderPosition: _interfaces.DropdownItemBorderPosition.Top,
    isOpen: !!isOpen,
    shouldHaveNoBorder: hasNoItems
  }, footer)));
};

var DropdownList = (0, _utils2.withTestAttributes)({})(DropdownListBase);
DropdownList.displayName = 'DropdownList';

var _default = /*#__PURE__*/(0, _react.memo)(DropdownList);

exports.default = _default;